import { render } from "./IdecoCriminal.vue?vue&type=template&id=7b63a10a&scoped=true"
import script from "./IdecoCriminal.vue?vue&type=script&lang=js"
export * from "./IdecoCriminal.vue?vue&type=script&lang=js"

import "./IdecoCriminal.vue?vue&type=style&index=0&id=7b63a10a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b63a10a"]])

export default __exports__